export default function isExpired(timestamp) {
    const currentDate = new Date();
    const expirationDate = Date.parse(timestamp);
    return currentDate > expirationDate;
}
